import React from 'react';
import { Spin, Typography } from 'antd';

const { Text } = Typography;

const Loader = ({ text = 'Yuklanmoqda...', overlay = false }) => {
  const content = (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: overlay ? '100vh' : '200px',
        gap: '16px',
      }}
    >
      <Spin size="large" />
      {text && <Text itemType="secondary">{text}</Text>}
    </div>
  );

  if (overlay) {
    return (
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(255, 255, 255, 0.9)',
          zIndex: 9999,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {content}
      </div>
    );
  }

  return content;
};

export default Loader;
